import React, { Suspense } from "react";
import Spinner from "./spinner";

export const SuspendSpin = props => {
  return <Suspense fallback={<Spinner isLoading={true} />}>{props.children}</Suspense>;
};
